import React from 'react';

const fallback = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=';

const UserInfo = ({ userInfo }) => {
  if (!userInfo) return null;

  return (
    <div>
      <div className="pro">
        <div className="profile-img">
          <a href={userInfo.url} target="_blank" rel="noopener noreferrer">
            <img
              src={userInfo.image[userInfo.image.length - 1]['#text'] || fallback}
              alt={`${userInfo.name}'s profile`}
              onError={(e) => { e.target.onerror = null; e.target.src = fallback; }}
            />
          </a>
        </div>
        <div className="profile">
          <p>{userInfo.name}</p>
          <p>total {userInfo.playcount} scrobbles</p>
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
